var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 136",
    d: "M22.3498 9.9169C21.3579 12.8972 16.7223 16.6875 11.965 19.9734C11.8952 20.0216 11.8012 20.0192 11.7325 19.9694C6.30917 16.0355 3.33137 14.7452 1.34847 9.91666C-0.630035 5.0988 6.22091 -2.93176 11.6953 3.23983C11.7754 3.33018 11.9231 3.33444 12.0067 3.24727C17.0112 -1.97075 24.5715 3.24133 22.3498 9.9169Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 137",
    d: "M1.50098 10.3691H6.38491C6.45668 10.3691 6.52295 10.3307 6.55856 10.2684L8.24898 7.31014C8.33907 7.15247 8.57572 7.18679 8.61731 7.36356L10.3163 14.5843C10.3641 14.7873 10.6519 14.7908 10.7045 14.5889L13.3135 4.58774C13.3651 4.39001 13.645 4.3878 13.6997 4.5847L15.8763 12.4205C15.9234 12.5898 16.1502 12.6205 16.2406 12.4699L17.4427 10.4662C17.4789 10.406 17.544 10.3691 17.6142 10.3691H22.001",
    stroke: "currentColor",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryHealth);
export default __webpack_public_path__ + "static/media/project-category-health.a9aeb6f0.svg";
export { ForwardRef as ReactComponent };